import { BuildingApi } from '@wiz-api/personnel-position'
import { map, get, find, concat, isEmpty } from 'lodash'

const buildingApi = new BuildingApi()

/** ************************************************ 建筑列表 **************************************** */
// 建筑列表
let buildingList = []
// 建筑图标列表
let buildingIconList = []
let cloudRender
let drawHandler
// 标签定位位置类型
const markPosType = {
  leftTop: 0,
  midTop: 1,
  rightTop: 2,
  leftBottom: 3,
  midBottom: 4,
  rightBottom: 5,
}

// 初始化数据
const initData = () => {
  buildingList = []
  buildingIconList = []
  drawHandler = null
}

// 打开建筑详情
const openBuildingDetail = (buildingId) => {
  if (!buildingId) {
    return
  }
  const openEvent = new CustomEvent('openComponent', {
    detail: {
      toCom: {
        code: 'BuildingOperation',
        origin: 'tag',
        name: '建筑操作',
        originTagName: 'BuildingList',
      },
      type: 'tags',
      props: {
        buildingId,
      },
    },
  })
  window.dispatchEvent(openEvent)
}

// 获取建筑列表
const getBuildingList = async (sceneId) => {
  const [err, res] = await buildingApi.getList({
    sceneId,
    skipCount: 0,
    maxResultCount: 1000,
  })
  if (!err && res) {
    return res.items
  }
  return []
}

// 绘制标签
const drawMarker = async (player, buildingDetail) => {
  if (!player.Native) return
  const points = JSON.parse(buildingDetail.coordinate)
  const posArr = [points[0].x, points[0].y, points[0].z]
  const singleOption = {
    id: await getUUID(),
    pos: posArr,
    background: 'buildFloor',
    visible: true,
    nodeOffset: [0, 0],
    text: buildingDetail.name,
    textColor: '#ffff00ff',
    hasTriangle: true,
    markPosType: markPosType.midBottom,
  }
  // 文字
  const res = await cloudRender.Marker.createBySingleLine(singleOption)
  if (res.status) {
    const data = map(res.data, (item) => {
      return {
        id: item,
        buildingId: buildingDetail.id,
      }
    })
    buildingIconList = concat(buildingIconList, data)
  }
}

// 生成UUID
const getUUID = () => {
  const tempUrl = URL.createObjectURL(new Blob())
  const uuid = tempUrl.toString()
  URL.revokeObjectURL(tempUrl)
  return uuid.substring(uuid.lastIndexOf('/') + 1)
}

// 标签事件
const markerClick = (e) => {
  // 左键点击并且有id
  if (e?.type === 1 && !isEmpty(e?.markerId)) {
    const buildingInfo = find(buildingIconList, (item) => {
      return item.id === e.markerId
    })
    if (buildingInfo) {
      // 移动到视角
      openBuildingDetail(get(buildingInfo, 'buildingId'))
    }
  }
}

// 创建建筑
const create = async (player, sourceId, propCloudRender) => {
  if (!player.Native) {
    return
  }
  // 初始化数据
  initData()
  cloudRender = propCloudRender
  cloudRender.Dispatch.on('Marker', markerClick)
  drawHandler = new Promise(async (resolve) => {
    // 获取建筑列表数据
    buildingList = await getBuildingList(sourceId)
    // 生成建筑
    await Promise.all(
      map(buildingList, (item) => {
        return drawMarker(player, item)
      })
    )
    resolve()
  })
}

// 销毁建筑
const destroy = async (player) => {
  if (!player.Native) {
    return
  }
  await drawHandler
  if (!get(cloudRender, 'Marker')) return
  // 销毁图标
  cloudRender.Marker.destroyMarker(map(buildingIconList, 'id'))
  // 取消标签的事件监听
  cloudRender.Dispatch.off('Marker', markerClick)
}

// 切换标签显示隐藏
const toggleDisplay = async (type) => {
  await drawHandler
  await cloudRender.Marker.updateBySingleLine(
    map(buildingIconList, (item) => {
      return {
        id: item.id,
        visible: type,
      }
    })
  )
}

// 隐藏标签
const hidden = async () => {
  await toggleDisplay(false)
}

// 重新显示标签
const display = async () => {
  await toggleDisplay(true)
}
export default { create, destroy, hidden, display }
